import React, { useMemo } from 'react';
import {
	useUserSettingsWorkplaceListQuery,
	Workplace,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import UserSettingsWorkplaceItem from './UserSettingsWorkplaceItem';
import styles from './UserSettingsWorkplace.module.scss';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import { WorkplaceType } from '../../../Manager/Enums/WorkplaceType.enum';

interface Props {
	userId: string;
	onConfirm: () => void;
}

export interface WorkplaceTreeItem {
	id: string;
	name: string;
	address: string;
	type: WorkplaceType;
	children?: WorkplaceTreeItem[];
}

const UserSettingsWorkplace: React.FC<Props> = ({ userId, onConfirm }) => {
	const { data, isLoading } = useUserSettingsWorkplaceListQuery({ userId });

	const createTree = (
		items: Workplace[],
		parentId: string | null = null,
	): WorkplaceTreeItem[] | undefined => {
		const tree: WorkplaceTreeItem[] = [];

		items?.forEach(item => {
			if (item.parentWorkplaceId === parentId) {
				tree.push({
					id: item.id,
					name: item.name!,
					type: item.type! as WorkplaceType,
					address: item.address?.fullAddress!,
					children: createTree(items, item.id),
				});
			}
		});

		return tree.length > 0 ? tree : undefined;
	};

	const workplaceTree: WorkplaceTreeItem[] | undefined = useMemo(() => {
		return createTree(
			data?.workplaceMembers?.data?.map(item => item?.workplace) as Workplace[],
			null,
		);
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{workplaceTree?.map(item => (
				<UserSettingsWorkplaceItem item={item} />
			))}
			<div className={styles.buttonWrapper}>
				<Button
					theme={Theme.GREEN}
					title='base.shared.ok'
					onClick={onConfirm}
					className={styles.button}
				/>
			</div>
		</div>
	);
};

export default UserSettingsWorkplace;
